<div class="body">
  <div class="label">{{ label }}</div>
  <div class="value">
    <ng-content></ng-content>
  </div>
</div>
